import axios from "axios";
import { api } from "~/router/apiConfig";

export function index(typeId) {
  return axios.get(
    api.path("userSettingLayout.index", {
      typeId
    })
  );
}

export function update(typeId, request) {
  return axios.put(
    api.path("userSettingLayout.update", {
      typeId
    }),
    request
  );
}
